import { RequestConfig } from '@/interface'

const PRIFIX = 'fpgl/qygl/'
const CPY_PRIFIX = 'qygl/cpy/'
const SXED_PRIFIX = 'fpgl/sxed/'

const firmConfig: RequestConfig = {
  // 企业列表
  qylb: {
    url: `${PRIFIX}queryPageList`,
    method: 'post'
  },
  // 企业列表（高风险）
  gfxqylb: {
    url: `${PRIFIX}queryPageListHigh`,
    method: 'post'
  },
  // 企业详情
  qyxq: {
    url: `${PRIFIX}detail`,
    method: 'post'
  },
  // 授信额度退回
  sxedth: {
    url: `${PRIFIX}sxedth`,
    method: 'post'
  },
  // 授信额度下载
  sxedxz: {
    url: `${PRIFIX}sxedxz`,
    method: 'post'
  },
  // 更新额度有效期
  sxedyxqtz: {
    url: `${PRIFIX}sxedyxqtz`,
    method: 'get'
  },
  // 授信额度列表
  sxedList: {
    url: `${SXED_PRIFIX}queryPageList`,
    method: 'post'
  },
  // 获取授信额度信息
  getSxed: {
    url: `${SXED_PRIFIX}getSxed`,
    method: 'get'
  },
  // 企业信息
  userQyxx: {
    url: `${PRIFIX}userQyxx`,
    method: 'post'
  },
  // 企业列表导出
  queryPageListExport: {
    url: `${PRIFIX}queryPageListExport`,
    method: 'post'
  },
  // 高风险列表导出
  queryPageListHighExport: {
    url: `${PRIFIX}queryPageListHighExport`,
    method: 'post'
  },
  // 发票预警配置
  // fpkjConfAddOrUpdate: {
  //   url: `${PRIFIX}fpkjConfAddOrUpdate`,
  //   method: 'post'
  // },
  // // 发票预警信息
  // fpkjConfInfo: {
  //   url: `${PRIFIX}fpkjConfInfo`,
  //   method: 'post'
  // },
  // 授信额度发票预警配置
  sxedFpkjAddOrUpdate: {
    url: `${PRIFIX}sxedFpkjAddOrUpdate`,
    method: 'post'
  },
  // 授信额度发票预警信息
  sxedFpkjInfo: {
    url: `${PRIFIX}sxedFpkjInfo`,
    method: 'post'
  },
  // 企业信息更新
  qyxxGx: {
    url: `${PRIFIX}qyxxGx`,
    method: 'post'
  },
  // 授信额度更新
  sxedgx: {
    url: `${PRIFIX}sxedgx`,
    method: 'post'
  },
  // 汇总确认取消
  hzqrcancel: {
    url: `${PRIFIX}hzqrcancel`,
    method: 'post'
  },
  // 汇总确认提交
  hzqrsubmit: {
    url: `${PRIFIX}hzqrsubmit`,
    method: 'post'
  },
  // 申请汇总查询历史信息
  sqhz: {
    url: `${PRIFIX}sqhz`,
    method: 'post'
  },
  // 查询是否汇总状态(如果传来的nsrsbh没有存在返回列表则说明没有之前的数据)
  selhzstatus: {
    url: `${PRIFIX}selhzstatus`,
    method: 'post'
  },
  // 汇总确认进行前更新状态
  refreshHZXX: {
    url: `${PRIFIX}refreshHZXX`,
    method: 'post'
  },
  // 查询库存列表
  cpykc: {
    url: `${CPY_PRIFIX}cpykc`,
    method: 'post'
  },
  // 查询可用库存
  cxkykc: {
    url: `${CPY_PRIFIX}cxkykc`,
    method: 'post'
  },
  // 更新可用库存
  gxkykc: {
    url: `${CPY_PRIFIX}gxkykc`,
    method: 'post'
  },
  // 更新阈值
  gxyz: {
    url: `${CPY_PRIFIX}gxyz`,
    method: 'post'
  },
  // 成品油更新
  cpySync: {
    url: `${CPY_PRIFIX}/sync`,
    method: 'get'
  },
  // 自动下载库存
  zdxzkc: {
    url: `${CPY_PRIFIX}zdxzkc`,
    method: 'post'
  }
}
export default firmConfig
